(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kroq-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.dataset.kroqFaqInit) return;
      root.dataset.kroqFaqInit = '1';
      var input = root.querySelector('[data-kroq-faq-search]');
      if (!input) return;
      var items = root.querySelectorAll('[data-kroq-faq-item]');
      var empty = root.querySelector('[data-kroq-faq-empty]');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var visible = 0;
        items.forEach(function (item) {
          var match = item.textContent.toLowerCase().indexOf(q) !== -1;
          item.hidden = q && !match;
          if (!item.hidden) visible++;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    }
    function boot() { document.querySelectorAll('.kroq-faq').forEach(initFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kroq-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' €';
      }
    }

    function initProduct(root) {
      if (root.dataset.kroqInit) return;
      root.dataset.kroqInit = '1';

      var form = root.querySelector('[data-kroq-form]');

      /* ── Galerie : miniatures ── */
      var mainImg = root.querySelector('[data-kroq-main-image]');
      root.querySelectorAll('[data-kroq-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
          root.querySelectorAll('[data-kroq-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });

      /* ── Quantité ── */
      var qtyWrap = root.querySelector('[data-kroq-qty]');
      if (qtyWrap) {
        var qtyInput = qtyWrap.querySelector('input');
        qtyWrap.querySelector('[data-kroq-qty-minus]').addEventListener('click', function () {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        });
        qtyWrap.querySelector('[data-kroq-qty-plus]').addEventListener('click', function () {
          qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        });
      }

      /* ── Résolution des variantes ── */
      var variants = [];
      var variantsTag = root.querySelector('[data-kroq-variants]');
      if (variantsTag) { try { variants = JSON.parse(variantsTag.textContent); } catch (e) {} }
      var idInput = root.querySelector('[data-kroq-variant-id]');
      var priceEl = root.querySelector('[data-kroq-price]');
      var compareEl = root.querySelector('[data-kroq-compare]');
      var atc = root.querySelector('[data-kroq-atc]');
      var atcLabel = root.querySelector('[data-kroq-atc-label]');
      var buynow = root.querySelector('[data-kroq-buynow]');
      var stickyPrice = root.querySelector('[data-kroq-sticky-price]');
      var currency = root.getAttribute('data-currency') || 'EUR';

      function getSelectedOptions() {
        var opts = [];
        root.querySelectorAll('[data-kroq-option]').forEach(function (input) {
          if (input.checked) opts[parseInt(input.dataset.kroqOption, 10) - 1] = input.value;
        });
        return opts;
      }

      function matchVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function updateVariant() {
        if (!variants.length) return;
        var opts = getSelectedOptions();
        var v = opts.length ? matchVariant(opts) : variants[0];
        if (!v) v = variants[0];
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, currency);
        if (stickyPrice) stickyPrice.textContent = money(v.price, currency);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.style.display = '';
            compareEl.textContent = money(v.compare_at_price, currency);
          } else {
            compareEl.style.display = 'none';
          }
        }
        var available = v.available;
        [atc, buynow].forEach(function (btn) { if (btn) btn.disabled = !available; });
        if (atcLabel) atcLabel.textContent = available ? 'Ajouter au panier' : 'Indisponible';
      }

      root.querySelectorAll('[data-kroq-option]').forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });
      updateVariant();

      /* ── Ajout AJAX + ouverture drawer ── */
      function refreshCartEvent(button, didError) {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            (button || document).dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'kroq-pdp', data: { source: 'kroq-pdp', itemCount: cart ? cart.item_count : 0, didError: !!didError } }
            }));
          });
      }

      function ajaxAdd() {
        var fd = new FormData(form);
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/javascript' }, body: fd })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc) atc.disabled = true;
          ajaxAdd()
            .then(function () { refreshCartEvent(atc, false); })
            .catch(function (err) { console.error('[Kroq] add error', err); })
            .finally(function () { if (atc) atc.disabled = false; });
        });
      }

      if (buynow) {
        buynow.addEventListener('click', function () {
          buynow.disabled = true;
          ajaxAdd()
            .then(function () { window.location.href = '/checkout'; })
            .catch(function (err) { console.error('[Kroq] buynow error', err); buynow.disabled = false; });
        });
      }

      /* ── Sticky CTA ── */
      var sticky = root.querySelector('[data-kroq-sticky]');
      if (sticky && atc && 'IntersectionObserver' in window) {
        var stickyAdd = sticky.querySelector('[data-kroq-sticky-add]');
        if (stickyAdd) stickyAdd.addEventListener('click', function () {
          if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { rootMargin: '0px 0px -100% 0px' });
        io.observe(atc);
      }

      /* ── Guide des tailles interactif ── */
      var sizer = root.querySelector('[data-kroq-sizer]');
      if (sizer) {
        // Seuils de poids → code de taille (kg). Source : référentiel Kroq.
        function sizeFromWeight(kg) {
          if (kg <= 0) return null;
          if (kg < 5) return 'XS';
          if (kg <= 10) return 'S';
          if (kg <= 20) return 'M';
          if (kg <= 35) return 'L';
          return 'XL';
        }
        var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];

        // Tailles réellement proposées par ce produit (option "Taille").
        var rawSizes = (sizer.getAttribute('data-sizes') || '').split('||');
        var available = []; // codes proposés
        var valueByCode = {}; // code -> libellé exact de l'option (pour cocher la variante)
        rawSizes.forEach(function (label) {
          var u = (label || '').toUpperCase().trim();
          if (!u) return;
          SIZE_ORDER.forEach(function (code) {
            // match du code en tant que mot (XS/S/M/L/XL) dans le libellé
            var re = new RegExp('(^|[^A-Z])' + code + '([^A-Z]|$)');
            if (re.test(u) && available.indexOf(code) === -1) {
              available.push(code);
              valueByCode[code] = label.trim();
            }
          });
        });

        var resultEl = sizer.querySelector('[data-kroq-sizer-result]');
        var breedSel = sizer.querySelector('[data-kroq-breed]');
        var weightInput = sizer.querySelector('[data-kroq-sizer-weight]');

        function selectVariantForCode(code) {
          // Coche le swatch de variante dont le libellé contient le code recommandé.
          var label = valueByCode[code];
          if (!label) return false;
          var matched = false;
          root.querySelectorAll('[data-kroq-option]').forEach(function (input) {
            if (!matched && input.value === label) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              matched = true;
            }
          });
          return matched;
        }

        function render(code) {
          if (!code) {
            resultEl.innerHTML = '<span class="kroq-sizer__placeholder">La taille recommandée s\'affichera ici.</span>';
            return;
          }
          var inStock = available.length === 0 || available.indexOf(code) !== -1;
          var msg, cls;
          if (available.length === 0) {
            // Produit "taille unique" / sans option de taille.
            msg = 'Taille unique — adaptée à votre chien.';
            cls = 'is-ok';
          } else if (inStock) {
            var picked = selectVariantForCode(code);
            msg = picked
              ? 'Disponible pour cet article — taille <strong>' + code + '</strong> sélectionnée ✓'
              : 'Taille <strong>' + code + '</strong> proposée pour cet article.';
            cls = 'is-ok';
          } else {
            msg = 'Taille <strong>' + code + '</strong> recommandée — non proposée sur cet article.';
            cls = 'is-warn';
          }
          resultEl.innerHTML =
            '<div class="kroq-sizer__badge">' + code + '</div>' +
            '<div class="kroq-sizer__msg ' + cls + '">' + msg + '</div>';
        }

        // Switch de mode (race / poids)
        sizer.querySelectorAll('[data-kroq-mode]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var mode = btn.getAttribute('data-kroq-mode');
            sizer.querySelectorAll('[data-kroq-mode]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
            sizer.querySelectorAll('[data-kroq-pane]').forEach(function (p) {
              p.hidden = p.getAttribute('data-kroq-pane') !== mode;
            });
          });
        });

        if (breedSel) breedSel.addEventListener('change', function () {
          render(sizeFromWeight(parseFloat(breedSel.value)));
        });
        if (weightInput) weightInput.addEventListener('input', function () {
          render(sizeFromWeight(parseFloat(weightInput.value)));
        });
      }
    }

    function boot() {
      document.querySelectorAll('[data-kroq-product]').forEach(initProduct);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
